import { Button, Box, Typography, alpha } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import FormModalContainer from './FormModalContainer.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'

const ConfirmationModalContainer = ({
  modalState,
  setModalState,
  setFinishModalState,
  confirmationData,
  confirmHandler,
  confirmHandlerQueries,
  customStyles,
  functionToDispatch,
  cancelText,
  customModalStyle,
}) => {
  const dispatch = useDispatch()
  const newBody = confirmationData?.body.split('"')
  const { enqueueSnackbar } = useSnackbar()
  const { t } = UseTranslation()
  const handleClose = () => {
    setModalState(false)
  }

  const moveToFinishStep = () => {
    if (functionToDispatch) {
      functionToDispatch(confirmHandlerQueries)
      handleClose()
    } else {
      dispatch(
        confirmHandler({
          queries: confirmHandlerQueries,
        }),
      ).then((response) => {
        if (response.meta.requestStatus === 'rejected') {
          enqueueSnackbar(confirmationData.error, {
            variant: 'error',
          })
        }
        if (response.meta.requestStatus === 'fulfilled') {
          handleClose()
          setFinishModalState(true)
        }
      })
    }
  }

  return (
    <Box>
      <FormModalContainer
        modalState={modalState}
        handleClose={handleClose}
        modalTitle={t?.[confirmationData?.header] || confirmationData?.header}
        cancelText={cancelText}
        customModalStyle={customModalStyle}
        mediumSize
        >
        <Box sx={[styles.textContainer, customStyles]}>
          <Typography component="span" variant="h4" sx={styles.messageText} className='finishModalBody'>
            {t?.[newBody?.[0]] || newBody?.[0]}
            <span className='main-text' style={{ color: `${confirmationData?.color}` }}>{t?.[newBody?.[1]] || newBody?.[1]}</span>
            {t?.[newBody?.[2]] || newBody?.[2]}
          </Typography>

            <Typography variant="h4" sx={styles.confirmationSubMsg}>
              {t?.[confirmationData?.subBody] || confirmationData?.subBody || `${t?.['Press “Yes” to confirm or “No” to cancel']}`}
            </Typography>

        </Box>

        <Box sx={styles.buttonsContainer} className='btns-container'>
          <Button sx={styles.cancelButton} onClick={handleClose}>
            {t?.[confirmationData?.cancelText] || confirmationData?.cancelText || `${t?.No}`}
          </Button>

          <Button sx={styles.confirmButton} type="button" onClick={moveToFinishStep}>
            {t?.[confirmationData?.confirmText] || confirmationData?.confirmText || `${t?.Yes}`}
          </Button>
        </Box>
      </FormModalContainer>
    </Box>
  )
}

const styles = {
  textContainer: {
    padding: { xs: '10px', sm: '20px 10px 10px 10px' },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 'solid 1px #e3e4ed',
    marginTop: '10px',
    padding: '20px 10px 10px 10px',

  },
  confirmButton: {
    width: 'fit-content',
    color: 'white',
    borderRadius: '10px',
    backgroundColor: 'primary.main',
    border: 0,
    padding: '10px 20px',
    fontSize: '14px',
    lineHeight: 1.43,
    textTransform: 'capitalize',
    minWidth: { xs: '100%', sm: '110px' },
    '&:hover, &:focus': {
      backgroundColor: alpha('#29cc8b', 0.75),
    },
    '&.disabled': {
      backgroundColor: alpha('#29cc8b', 0.5),
      pointerEvents: 'none',
    },
  },
  cancelButton: {
    color: 'primary.main',
    display: { xs: 'none', sm: 'flex' },
    borderRadius: '10px',
    backgroundColor: 'primary.light',
    border: '1px solid #29cc8b',
    padding: '10px 20px',
    fontSize: '14px',
    textTransform: 'capitalize',
    lineHeight: 1.43,
    marginRight: '10px',
    minWidth: { xs: 'fit-content', sm: '110px' },
    '&:hover, &:focus': {
      backgroundColor: alpha('#29cc8b', 0.75),
      color: 'white',
    },
  },
  messageText: {
    fontSize: { xs: '14px', sm: '16px' },
    '& span': {
      textTransform: 'capitalize',
    },
  },
  confirmationSubMsg: {
    display: 'block',
    marginTop: { xs: '8px', sm: '16px' },
    fontSize: { xs: '12px', sm: '14px' },
    fontWeight: '500',
    color: '#98a9bc',
  },
}

export default ConfirmationModalContainer
